/* Veilleuses « Petits Amis » (forêt, savane…) — configurateur commun. Monté sur chaque [data-va] de la page.
   Scène fixe (data-decor, ex. ps-decor.webp) sur la photo de l'arche (tr-photo.webp) ; prénom seul ou prénom + infos de naissance. */
(function(){
  function init(root){
  if(root.dataset.vaPret) return; root.dataset.vaPret='1';
  var BASE=root.dataset.base, VERSION_IMAGES='5';
  var NOM={size:80,max:330,yseul:256,yinfos:234,couleur:'#FFF4D6',vide:'rgba(255,244,214,.55)'}, INFOS={size:17,ecart:36,max:400};
  var etat={option:'prenom',prenom:'',date:'',heure:'',taille:'',poids:''};
  var APERCU=root.querySelector('.vn__apercu'), SVGNS='http://www.w3.org/2000/svg';
  function $(s){return root.querySelector(s)||APERCU.querySelector(s)}
  function img(id){return BASE+id+'.webp?v='+VERSION_IMAGES}
  $('[data-pf-photo]').setAttribute('href',img('tr-photo')); $('[data-pf-decor]').setAttribute('href',img(root.dataset.decor));

  // textes imprimés : 04/05/2026 · 12H34 · 52 CM · 3200 G
  function fDate(v){var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(v||'');return m?m[3]+'/'+m[2]+'/'+m[1]:''}
  function fHeure(v){var m=/^(\d{2}):(\d{2})/.exec(v||'');return m?m[1]+'H'+m[2]:''}
  function fTaille(v){var n=parseFloat(String(v).replace(',','.'));return n>0?String(Math.round(n*10)/10).replace('.',',')+' CM':''}
  function fPoids(v){var n=parseInt(v,10);return n>0?n+' G':''}
  function ligneInfos(){return [fDate(etat.date),fHeure(etat.heure),fTaille(etat.taille),fPoids(etat.poids)].filter(Boolean).join('   ·   ')}

  function ajuster(t,size,max){t.setAttribute('font-size',size);try{var w=t.getComputedTextLength();if(w>max)t.setAttribute('font-size',(size*max/w).toFixed(1))}catch(e){}}
  function rendu(){
    var avec=etat.option==='naissance';
    root.querySelectorAll('[data-option]').forEach(function(b){b.setAttribute('aria-checked',b.dataset.option===etat.option)});
    $('[data-pf-bloc-naissance]').hidden=!avec;
    var reste=13-Array.from(etat.prenom).length; $('[data-pf-compteur]').textContent=reste+(reste>1?' restants':' restant');
    var exemple=avec&&!ligneInfos(), ligne=avec?(ligneInfos()||'04/05/2026   ·   12H34   ·   52 CM   ·   3200 G'):'';
    var n=$('[data-pf-nom]'), i=$('[data-pf-infos]'), y=avec?NOM.yinfos:NOM.yseul;
    n.setAttribute('y',y); n.textContent=etat.prenom||'Prénom'; n.setAttribute('fill',etat.prenom?NOM.couleur:NOM.vide); ajuster(n,NOM.size,NOM.max);
    i.setAttribute('y',y+INFOS.ecart); i.textContent=ligne; i.setAttribute('fill',exemple?NOM.vide:NOM.couleur); ajuster(i,INFOS.size,INFOS.max);
    $('[data-pf-p-texte]').value=avec?'Prénom + infos de naissance':'Prénom seul';
    $('[data-pf-p-prenom]').value=etat.prenom;
    [['date',fDate(etat.date)],['heure',fHeure(etat.heure)],['taille',fTaille(etat.taille)],['poids',fPoids(etat.poids)]].forEach(function(k){
      var f=$('[data-pf-p-'+k[0]+']'); f.value=avec?k[1]:''; f.disabled=!avec||!k[1]});
  }
  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-option]'); if(!b||!root.contains(b)) return;
    etat.option=b.dataset.option; $('[data-pf-erreur-date]').hidden=true; rendu(); montrerApercu();
  });
  $('[data-pf-prenom]').addEventListener('input',function(e){
    var v=e.target.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿŒœ' \-]/g,'').replace(/\s{2,}/g,' ');
    v=Array.from(v).slice(0,13).join(''); if(v!==e.target.value) e.target.value=v;
    etat.prenom=v.trim(); $('[data-pf-erreur]').hidden=true; rendu(); montrerApercu();
  });
  ['date','heure','taille','poids'].forEach(function(k){
    $('[data-pf-'+k+']').addEventListener('input',function(e){etat[k]=e.target.value; if(k==='date') $('[data-pf-erreur-date]').hidden=true; rendu(); montrerApercu()});
  });

  // option ajoutée au panier avec la veilleuse : adaptateur secteur USB
  var OPTION={handle:'adaptateur-usb-prise-secteur-220v',variante:47304866333003,prixNum:4.49};
  var caseOpt=$('[data-pf-option-usb]'), blocOption=caseOpt.closest('.vn__carte'), prixOption=blocOption.querySelector('em');
  var prixBase=null;
  function lirePrix(t){var m=String(t||'').replace(/\s/g,'').match(/(\d+)[.,](\d{2})/);return m?parseFloat(m[1]+'.'+m[2]):null}
  function majPrixBouton(){
    var cibles=document.querySelectorAll('.kp-btn-prix'); if(!cibles.length) return;
    if(prixBase===null) prixBase=lirePrix(cibles[0].textContent); if(prixBase===null) return;
    var txt=(prixBase+(caseOpt.checked?OPTION.prixNum:0)).toFixed(2).replace('.',',')+' €';
    [].forEach.call(cibles,function(c){if(c.textContent!==txt) c.textContent=txt});
  }
  caseOpt.addEventListener('change',majPrixBouton);
  new MutationObserver(function(){majPrixBouton()}).observe(document.body,{childList:true,subtree:true,characterData:true});
  var vignette=document.createElement('img'); vignette.alt=''; vignette.width=48; vignette.height=48;
  vignette.setAttribute('style','width:48px;height:48px;object-fit:contain;border-radius:6px;background:#fff;flex:none;display:none');
  blocOption.insertBefore(vignette,blocOption.children[1]);
  fetch('/products/'+OPTION.handle+'.js').then(function(r){return r.json()}).then(function(p){
    var v=(p.variants||[]).filter(function(x){return x.id===OPTION.variante})[0]||p.variants[0];
    if(v){OPTION.variante=v.id; OPTION.prixNum=v.price/100; prixOption.textContent='+'+(v.price/100).toFixed(2).replace('.',',')+' €'; if(!v.available){blocOption.style.display='none';caseOpt.checked=false} majPrixBouton()}
    if(p.featured_image){vignette.src=p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_96x96$1$2'); vignette.style.display=''}
  }).catch(function(){});

  // s'installe dans le formulaire produit, juste avant le bouton d'ajout au panier
  var form=document.querySelector('form[data-product-form]')||document.querySelector('form[action*="/cart/add"]');
  if(form){
    var cible=form.querySelector('.product-single__add-to-cart');
    if(cible) cible.parentNode.insertBefore(root,cible); else form.appendChild(root);
  }

  // l'aperçu prend la place de la première photo du carrousel
  var apercu=APERCU, svg=apercu.querySelector('svg'), galerie=null;
  var media=document.querySelector('.product-single__media-group .product-single__media-wrapper .product--wrapper')||document.querySelector('.product-single__media-group .product-single__media');
  if(media){
    if(getComputedStyle(media).position==='static') media.style.position='relative';
    media.appendChild(apercu); apercu.classList.add('vn__apercu--galerie');
    galerie=media.closest('.product-single__media-wrapper')||media;
    var note=root.querySelector('.vn__note'); if(note) note.hidden=true;
  }
  function montrerApercu(){
    if(!galerie) return;
    var slider=galerie.closest('.slick-slider'), jq=window.jQuery;
    if(slider&&jq&&jq.fn&&jq.fn.slick){
      var $s=jq(slider), idx=jq(galerie).closest('.slick-slide').data('slick-index')||0;
      if($s.slick('slickCurrentSlide')!==idx) $s.slick('slickGoTo',idx);
      return;
    }
    if(galerie.offsetParent!==null) return;
    var id=(galerie.id||'').split('-').pop();
    var v=id&&document.querySelector('[data-thumbnail-id$="'+id+'"],[data-media-id$="'+id+'"],[href*="'+id+'"]');
    if(v) v.click();
  }

  // mobile : aperçu fixé en haut de l'écran pendant la personnalisation
  var sceneId='vaScene-'+Math.random().toString(36).slice(2,8), scene=document.createElementNS(SVGNS,'g');
  scene.setAttribute('id',sceneId);
  Array.prototype.slice.call(svg.childNodes).forEach(function(n){if(n.nodeName!=='defs') scene.appendChild(n)});
  svg.appendChild(scene);
  var flot=document.createElement('div'); flot.className='vn-flottant'; flot.setAttribute('aria-hidden','true');
  flot.innerHTML='<div class="vn-flottant__vue"><svg viewBox="0 0 805 805"><use href="#'+sceneId+'"/></svg></div>';
  document.body.appendChild(flot);
  var ZOOMS=[1,1.4,1.8], niveauZoom=0, vue=flot.querySelector('svg'), groupeZoom=document.createElement('div');
  var LOUPE='<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/>';
  groupeZoom.className='vn-zoom';
  groupeZoom.innerHTML='<button type="button" data-zoom="1" aria-label="Zoomer sur l\'aperçu">'+LOUPE+'<path d="M10.5 7.5v6M7.5 10.5h6"/></svg></button>'
    +'<button type="button" data-zoom="-1" aria-label="Dézoomer l\'aperçu">'+LOUPE+'<path d="M7.5 10.5h6"/></svg></button>';
  groupeZoom.addEventListener('click',function(e){var b=e.target.closest('[data-zoom]');if(!b)return;e.preventDefault();e.stopPropagation();
    niveauZoom=Math.max(0,Math.min(ZOOMS.length-1,niveauZoom+(+b.dataset.zoom)));appliquerZoom()});
  flot.appendChild(groupeZoom);
  function appliquerZoom(){
    var z=ZOOMS[niveauZoom]; vue.style.transformOrigin='50% 35%'; vue.style.transform=z===1?'':'scale('+z+')';
    groupeZoom.querySelector('[data-zoom="1"]').disabled=niveauZoom===ZOOMS.length-1; groupeZoom.querySelector('[data-zoom="-1"]').disabled=niveauZoom===0;
  }
  appliquerZoom();
  var zonePanier=form&&form.querySelector('.product-single__add-to-cart');
  function majFlottant(){
    if(window.innerWidth>768){flot.classList.remove('is-visible');return}
    var h=flot.offsetHeight||300, a=apercu.getBoundingClientRect(), p=(zonePanier||root).getBoundingClientRect();
    flot.classList.toggle('is-visible', a.bottom<=h && p.bottom>h);
  }
  window.addEventListener('scroll',majFlottant,{passive:true}); window.addEventListener('resize',majFlottant);

  // contrôle avant l'ajout au panier (bouton principal et barre collante)
  var optionAjoutee=false;
  function boutonAjout(t){return t.closest&&t.closest('button[name="add"], .btn--add-to-cart, [data-sticky-addtocart], .dbtfy-sticky-addtocart button')}
  function manque(){
    if(!etat.prenom){$('[data-pf-erreur]').hidden=false; $('[data-pf-prenom]').focus(); return true}
    if(etat.option==='naissance'&&!fDate(etat.date)){$('[data-pf-erreur-date]').hidden=false; $('[data-pf-date]').focus(); return true}
    return false;
  }
  document.addEventListener('click',function(e){
    var b=boutonAjout(e.target); if(!b) return;
    if(manque()){e.preventDefault(); e.stopImmediatePropagation(); root.scrollIntoView({behavior:'smooth',block:'center'}); return}
    if(caseOpt.checked&&!optionAjoutee){
      e.preventDefault(); e.stopImmediatePropagation();
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(OPTION.variante),quantity:1}]})})
        .then(function(){optionAjoutee=true;b.click()})
        .catch(function(){optionAjoutee=true;b.click()});
    }
  },true);
  if(form) form.addEventListener('submit',function(e){if(manque()){e.preventDefault();e.stopImmediatePropagation()}},true);

  // ordinateur : bouton « Voir l'aperçu » qui ouvre l'aperçu en grand
  var champPrenom=root.querySelector('.vn__prenom'), voir=document.createElement('button');
  voir.type='button'; voir.className='vn__voir'; voir.textContent='Voir l\'aperçu de ma veilleuse';
  var blocNaiss=root.querySelector('[data-pf-bloc-naissance]');   // en bas du formulaire, après les infos de naissance (même masquées)
  blocNaiss.parentNode.insertBefore(voir,blocNaiss.nextSibling);
  var fen=document.createElement('div'); fen.className='vn-fenetre'; fen.hidden=true;
  fen.setAttribute('role','dialog'); fen.setAttribute('aria-modal','true'); fen.setAttribute('aria-label','Aperçu de votre veilleuse');
  fen.innerHTML='<div class="vn-fenetre__boite"><button type="button" class="vn-fenetre__fermer" aria-label="Fermer">&times;</button>'
    +'<svg viewBox="0 0 805 805"><use href="#'+sceneId+'"/></svg><p class="vn-fenetre__texte"></p></div>';
  document.body.appendChild(fen);
  function ouvrirFen(){
    fen.querySelector('.vn-fenetre__texte').textContent=(etat.prenom||'Prénom')+(etat.option==='naissance'&&ligneInfos()?' · '+ligneInfos().replace(/\s{3}·\s{3}/g,' · '):'');
    fen.hidden=false; fen.querySelector('.vn-fenetre__fermer').focus();
  }
  function fermerFen(){fen.hidden=true; voir.focus()}
  voir.addEventListener('click',ouvrirFen);
  fen.addEventListener('click',function(e){if(e.target===fen||e.target.closest('.vn-fenetre__fermer')) fermerFen()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!fen.hidden) fermerFen()});

  // vignettes du panier (script commun aux veilleuses)
  if(!window.vnPanier){var sp=document.createElement('script'); sp.src=BASE+'vn-veilleuse-panier.js?v=h'+Math.floor(Date.now()/36e5); sp.defer=true; document.head.appendChild(sp)}

  rendu(); majFlottant(); majPrixBouton();
  if(document.fonts&&document.fonts.load) Promise.all([document.fonts.load('700 80px "Dancing Script"'),document.fonts.load('600 17px Poppins')]).then(rendu,rendu);
  }
  function go(){document.querySelectorAll('[data-va]').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
})();
